import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useUpdatePersonalTreatmentPlanTemplateMutation } from "@/modules/admin/treatment/services/__generated__/useUpdatePersonalTreatmentPlanTemplateMutation.graphql"

const mutation = graphql`
  mutation useUpdatePersonalTreatmentPlanTemplateMutation($input: UpdatePersonalTreatmentPlanTemplateInput!) {
    updatePersonalTreatmentPlanTemplate(input: $input) {
      treatmentPlanTemplate {
        id
        name
        countries
        languages {
          language
          title
          followUpInstructions
          synonym
          recommendedTreatment
        }
        icdDiagnoses {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
const useUpdatePersonalTreatmentPlanTemplateMutationHook = () => {
  const [commit, isFlight] = useMutation<useUpdatePersonalTreatmentPlanTemplateMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useUpdatePersonalTreatmentPlanTemplateMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useUpdatePersonalTreatmentPlanTemplateMutationHook }
